import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { CustomEase } from 'gsap/CustomEase'

gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase)

CustomEase.create('osmo', 'M0,0 C0.625,0.05 0,1 1,1')
CustomEase.create("energy", "M0,0 C0.32,0.72 0,1 1,1")


/**
 *   - data-anim-trigger: parent element for the animation
 *   - data-anim: animation type (e.g., 'heading', 'fade') 
 *   - data-anim-delay: delay before animation starts (in seconds)
 */

export const initInviewAnimations = () => {

  const animParents = document.querySelectorAll('[data-anim-trigger]')

	if (animParents.length === 0) return

	document.fonts.ready.then(() => {
		animParents.forEach((element) => {
			const animOffset = element.dataset.animOffset
			const animElements = element.querySelectorAll('[data-anim]')
			createTimeline(element, animElements, animOffset)
		})
	})
}

const createTimeline = (parent, animElements, offset = '70%') => {
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: parent,
			start: `top ${offset}`,
			invalidateOnRefresh: true,
			once: true
		}
	})

	parent.dataset.animTrigger = 'ready'

	if (window.isLivePreview) {
		parent.dataset.animTrigger = 'live-preview'
		return
	}

	animElements.forEach((element) => {
		const type = element.dataset.anim
		const delay = element.dataset.animDelay

		createAnimation(tl, element, type, delay)
	})
}

const createAnimation = (tl, element, type, delay = 0) => {

  switch (type) {

		case 'heading':

			const splitHeading = SplitText.create(element, {
				type: 'lines, words',
				linesClass: 'line++',
				wordsClass: 'word++',
				mask: 'lines',
				aria: false
			})

			tl.fromTo(splitHeading.words, {
				y: '110%',
			}, {
				y: 0,
				duration: 1.25,
				stagger: 0.1,
				ease: 'energy',
			}, delay)

			const highlight = element.querySelectorAll('i')

			tl.add(() => {
				highlight.forEach(highlight => highlight.classList.add('play'))
			}, '-=1.25')

		break
		
		case 'fade':

			tl.fromTo(element, {
				y: 125,
				opacity: 0
			}, {
				y: 0,
				opacity: 1,
				duration: 1.4,
				ease: 'energy',
			}, delay)
			
		break
		case 'fade-in':

			tl.fromTo(element, {
				opacity: 0
			}, {
				opacity: 1,
				duration: 1.4,
				ease: 'energy',
			}, delay)
			
		break
		case 'fade-left':

			tl.fromTo(element, {
				y: 125,
				x: -125,
				rotate: -7,
				opacity: 0
			}, {
				y: 0,
				x: 0,
				rotate: 0,
				opacity: 1,
				duration: 1.4,
				ease: 'energy',
			}, delay)

		break
		case 'fade-right':

			tl.fromTo(element, {
				y: 125,
				x: 125,
				rotate: 7,
				opacity: 0
			}, {
				y: 0,
				x: 0,
				rotate: 0,
				opacity: 1,
				duration: 1.4,
				ease: 'energy',
			}, delay)

		break
		case 'glow': 

			tl.fromTo(element, {
				scale: 1.25,
				opacity: 0,
			}, {
				scale: 1,
				opacity: 0.6,
				duration: 6,
				ease: 'expo.out',
			}, delay)

		break
		case 'lines':

			const splitLines = SplitText.create(element, {
				type: 'lines',
				linesClass: 'line++',
				mask: 'lines',
				aria: false
			})

			tl.fromTo(splitLines.lines, {
				y: '110%',
			}, {
				y: 0,
				duration: 1.25,
				stagger: 0.05,
				ease: 'energy',
			}, delay)

		break
  }
}